import type { PageKind, PagePlan, PdfSize, Slot } from './types';

export const A5: PdfSize = { width: 419.52, height: 595.32 };
export const A4: PdfSize = { width: 595.44, height: 841.68 };

const a5Slots: Slot[] = [
  { id: 'a5-upper', left: 0, top: 23.1, width: 406.0, height: 263.1, rotation: 90 },
  { id: 'a5-lower', left: 0, top: 286.47, width: 406.0, height: 283.8, rotation: 90 },
];

const a4Slots: Slot[] = [
  { id: 'a4-upper-left', left: 0, top: 22.5, width: 291.75, height: 396.3, rotation: 0 },
  { id: 'a4-upper-right', left: 292.5, top: 23.55, width: 283.6, height: 395.25, rotation: 0 },
  { id: 'a4-lower-left', left: 0, top: 418.8, width: 291.5, height: 398.2, rotation: 0 },
  { id: 'a4-lower-right', left: 291.5, top: 424.0, width: 287.08, height: 392.5, rotation: 0 },
];

function makePage(kind: PageKind, startIndex: number, count: number): PagePlan {
  const slots = kind === 'A5' ? a5Slots : a4Slots;
  return {
    kind,
    size: kind === 'A5' ? A5 : A4,
    placements: slots.slice(0, count).map((slot, offset) => ({ orderIndex: startIndex + offset, slot })),
  };
}

/** Deterministic row-major allocation. It preserves every zero-based order index exactly once. */
export function allocateLayout(count: number): PagePlan[] {
  if (!Number.isInteger(count) || count < 0) throw new RangeError('Order count must be a non-negative integer.');
  if (count === 0) return [];

  const pages: PagePlan[] = [];
  let remaining = count;
  let startIndex = 0;
  while (remaining > 0) {
    if (remaining <= 2) {
      pages.push(makePage('A5', startIndex, remaining));
      break;
    }
    const pageCount = Math.min(4, remaining);
    pages.push(makePage('A4', startIndex, pageCount));
    startIndex += pageCount;
    remaining -= pageCount;
  }
  return pages;
}

export function expectedPageCount(count: number): number {
  return count === 0 ? 0 : Math.ceil(count / 4);
}
